import { useEffect } from 'react'
import { useAppDispatch, useAppState } from 'Context/AppContext/AppContext'
import { UPDATE_FEATURE_GATING_LIMIT } from 'TypeDefs/AppContext'
import { useLazyQuery } from '@apollo/client'
import GET_FEATURE_GATING_LIMIT from 'Apollo/Queries/GetFeatureGatingLimit'
import { client } from 'Test/Helpers/withMockProvider'

const useFeatureGatingConfig = () => {
  const dispatch = useAppDispatch()

  const {
    nonprofitOrgConfig: { platformPlan, orgId },
    userConfig: user,
  } = useAppState()

  const [getFeatureGatingLimit] = useLazyQuery(GET_FEATURE_GATING_LIMIT, {
    context: {
      clientName: 'batched',
    },
    onCompleted: (data) => {
      dispatch({
        type: UPDATE_FEATURE_GATING_LIMIT,
        featureGatingLimit: data.featureGatingLimit,
      })
    },
  })

  useEffect(() => {
    if (orgId && user.id) {
      getFeatureGatingLimit({
        variables: {
          planName: platformPlan,
        },
      })
    }
  }, [getFeatureGatingLimit, orgId, platformPlan, user.id])
}

export default useFeatureGatingConfig
